import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import {
  MarkupButton,
  SectionButton,
  LinkButton
} from "react-mobiledoc-editor";
import ListIcon from "react-icons/lib/md/format-list-bulleted";
import NumberListIcon from "react-icons/lib/md/format-list-numbered";
import BoldIcon from "react-icons/lib/md/format-bold";
import ItalicIcon from "react-icons/lib/md/format-italic";
import LinkIcon from "react-icons/lib/md/insert-link";
import UnderlineIcon from "react-icons/lib/md/format-underlined";
import SizeIcon from "react-icons/lib/md/format-size";

export default class Toolbar extends React.Component {
  static contextTypes = {
    editor: PropTypes.object
  };

  state = {
    visible: false,
    sizeMenu: false,
    x: 0,
    y: 0
  };

  componentDidMount() {
    const { editor } = this.context;
    editor.cursorDidChange(this.updateVisibility);
  }

  updateVisibility = () => {
    const { editor } = this.context;

    if (!editor.range || !editor.range.direction) {
      this.setState({ visible: false });
      return;
    }

    const range = window.getSelection().getRangeAt(0);
    const rect = range.getBoundingClientRect();
    const parentRect = editor.element.getBoundingClientRect();

    // pin to left side of close to edge of window
    const x = Math.max(64, rect.left - parentRect.left + rect.width * 0.5);
    const y = parentRect.top + parentRect.height - rect.top + 32;

    this.setState({ visible: true, x, y });
  };

  render() {
    const { visible, x, y, sizeMenu } = this.state;

    return (
      <div
        className={cn("editor-toolbar", { visible })}
        style={{ left: x, bottom: y }}
      >
        <MarkupButton tag="strong" type="button">
          <BoldIcon size={18} />
        </MarkupButton>
        <MarkupButton tag="em" type="button">
          <ItalicIcon size={18} />
        </MarkupButton>
        <MarkupButton tag="u" type="button">
          <UnderlineIcon size={18} />
        </MarkupButton>
        <button onClick={() => this.setState({ sizeMenu: true })} type="button">
          <SizeIcon size={18} />
        </button>
        <SectionButton tag="ul" type="button">
          <ListIcon size={18} />
        </SectionButton>
        <SectionButton tag="ol" type="button">
          <NumberListIcon size={18} />
        </SectionButton>
        <LinkButton type="button">
          <LinkIcon size={18} />
        </LinkButton>
        {sizeMenu && (
          <div className="text-size-menu">
            <SectionButton tag="h1" type="button">
              <h1>Heading 1</h1>
            </SectionButton>
            <SectionButton tag="h2" type="button">
              <h2>Heading 2</h2>
            </SectionButton>
            <SectionButton tag="h3" type="button">
              <h3>Heading 3</h3>
            </SectionButton>
            <SectionButton tag="h4" type="button">
              <h4>Heading 4</h4>
            </SectionButton>
            <SectionButton tag="h5" type="button">
              <h5>Heading 5</h5>
            </SectionButton>
            <SectionButton tag="h6" type="button">
              <h6>Heading 6</h6>
            </SectionButton>
            <button
              onClick={() => this.setState({ sizeMenu: false })}
              type="button"
            >
              Back
            </button>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/editor/Toolbar.js